export class ConfirmationRedirectError implements Error {
  name: string;
  message: string;
  stack?: string;
}
